export default "__VITE_ASSET__DZRTntg0__"